import { createGqlQuery } from '../fetcher';
import { Form } from '../queries/form.query';
import type * as Types from '../types';

export const useFormQuery = createGqlQuery<Types.FormQueryVariables, Types.FormQuery>(
  (variables) => ['form', variables],
  Form,
);
